import { type LocationQuery, stringifyQuery } from 'vue-router'

import { toLiveRhinoshieldBase } from '@/utils/rhinoshieldDomain'

// ditto-web 跑在 my. 子網域（my.rhinoshield.tw、my.dev.rhinoshield.tw），去掉 my. 前綴即得對應的
// rhinix 網域，prod / staging 皆成立（TH 的 .co.th 由 toLiveRhinoshieldBase 修正）。
const MY_SUBDOMAIN_PREFIX = /^my\./

// 本地 ditto-web 沒有 my. 子網域；devStoreId 固定為 'tw'，對應 rhinix staging 網域。
const DEV_RHINIX_ORIGIN = 'https://dev.rhinoshield.tw'

export function resolveRhinixOrigin(location: { host: string; protocol: string }): string {
  const { protocol, host } = location
  if (host.startsWith('my.')) {
    return `${protocol}//${toLiveRhinoshieldBase(host.replace(MY_SUBDOMAIN_PREFIX, ''))}`
  }
  return DEV_RHINIX_ORIGIN
}

export function buildRhinixUrl(origin: string, path: string, query: LocationQuery): string {
  const qs = stringifyQuery(query)
  return `${origin}${path}${qs.length > 0 ? `?${qs}` : ''}`
}
